<template>
    <div class="wrapper">
        <div class="content">
            <div class="reg-and-log-loader" v-if="loading">
                <div>
                    <Loader />
                </div>
            </div>
            <section class="registerForm" v-if="haveAccount == 0">
                <header>
                <h4>Utwórz dane do logowania</h4>
                </header>
                <div class="data">
                <div class="input-container">
                    <header>
                    <h6 v-if="email">Email</h6>
                    </header>
                    <div class="input-box">
                    <input class="data" :class="{ error: validValues[0].value == 1 }" type="email" placeholder="Email*" v-model="email" @blur="storeInLocalStorage(email, 'email', 'formData')">
                    <i class="material-icons" v-if="validValues[0].value == 1">close</i>
                    </div>
                    <p v-if="validValues[0].value == 1">{{ validValues[0].text }}</p>
                </div>
                <div class="input-container">
                    <header>
                    <h6 v-if="password1">Hasło</h6>
                    </header>
                    <div class="input-box">
                    <input class="data" :class="{ error: validValues[1].value == 1 }" type="password" placeholder="Hasło*" v-model="password1">
                    <i class="material-icons" v-if="validValues[1].value == 1">close</i>
                    </div>
                    <p v-if="validValues[1].value == 1">{{ validValues[1].text }}</p>
                </div>
                <div class="password-criteria">
                    <ul>
                    <li>
                    <i class="material-icons" :class="{ done: password[0].value == 1 }">{{ passwordIcon(password[0].value) }}</i>
                    <p>Min. 8 znaków</p>
                    </li>
                    <li>
                    <i class="material-icons" :class="{ done: password[1].value == 1 }">{{ passwordIcon(password[1].value) }}</i>
                    <p>Min. 1 wielka litera</p>
                    </li>
                    <li>
                    <i class="material-icons" :class="{ done: password[2].value == 1 }">{{ passwordIcon(password[2].value) }}</i>
                    <p>Min. 1 mała litera</p>
                    </li>
                    <li>
                    <i class="material-icons" :class="{ done: password[3].value == 1 }">{{ passwordIcon(password[3].value) }}</i>
                    <p>Min. 1 znak specjalny</p>
                    </li>
                    <li>
                    <i class="material-icons" :class="{ done: password[4].value == 1 }">{{ passwordIcon(password[4].value) }}</i>
                    <p>Min. 1 cyfra</p>
                    </li>
                    <li>
                    <i class="material-icons" :class="{ done: password[5].value == 1 }">{{ passwordIcon(password[5].value) }}</i>
                    <p>Nie zawiera imienia i nazwiska</p>
                    </li>
                    </ul>
                </div>
                <div class="input-container">
                    <header>
                    <h6 v-if="password2">Powtórz hasło</h6>
                    </header>
                    <div class="input-box">
                    <input class="data" :class="{ error: validValues[2].value == 1 }" type="password" placeholder="Powtórz hasło*" v-model="password2">
                    <i class="material-icons" v-if="validValues[2].value == 1">close</i>
                    </div>
                    <p v-if="validValues[2].value == 1">{{ validValues[2].text }}</p>
                </div>
                </div>
            </section>
            <section>
                <header>
                    <h4>Wybierz sposób podpisania umowy</h4>
                    <div class="icon" title="Infomacje dotyczące sposobu podpisania umowy" @click="showPopup(0)">
                        <i class="material-icons">info</i>
                    </div>
                </header>
                <div class="flex-center">
                    <button class="default reverse" :class="{ active: contractSigningMethod == 1 }" @click="contractSigningMethod = 1, storeInLocalStorage(contractSigningMethod, 'contractSigningMethod', 'step2State')">Przez kuriera</button>
                    <button class="default reverse" :class="{ active: contractSigningMethod == 0 }" @click="contractSigningMethod = 0, storeInLocalStorage(contractSigningMethod, 'contractSigningMethod', 'step2State')">Na miejscu w siedzibie AFK</button>
                </div>
                <div class="data" v-if="contractSigningMethod == 0">
                    <div class="contact-info">
                        <h4>Kontakt z nami:</h4>
                        <ul>
                            <li><p><i class="material-icons">place</i> <span>ul. Świeradowska 51-57 , 50-559 Wrocław, I piętro Centrum Handlowe Ferio Gaj</span></p></li>
                            <li><p><i class="material-icons">watch_later</i> poniedziałek – piątek 9:00-17:00</p></li>
                            <li><p><i class="material-icons">call</i> +48 71 336 95 21</p></li>
                            <li><p><i class="material-icons">email</i> bok@afkcob.pl</p></li>
                            <li><p>Skontaktujemy się z Tobą w najbliższym dniu roboczym w celu umówienia spotkania</p></li>
                        </ul>
                    </div>
                </div>
            </section>
            <section v-if="contractSigningMethod == 1">
                <header>
                    <h4>Podaj adres, pod który ma zastać wysłana umowa</h4>
                </header>
                <div class="data">
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.name">Imię</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[0].value == 1 }" placeholder="Imię*" v-model="courierData.name" @blur="storeObjectInLocalStore(courierData.name, 'name', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[0].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[0].value == 1">{{ validCourierDataValues[0].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.surname">Nazwisko</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[1].value == 1 }" placeholder="Nazwisko*" v-model="courierData.surname" @blur="storeObjectInLocalStore(courierData.surname, 'surname', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[1].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[1].value == 1">{{ validCourierDataValues[1].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.companyName">Nazwa firmy</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[7].value == 1 }" placeholder="Nazwa firmy" v-model="courierData.companyName" @blur="storeObjectInLocalStore(courierData.companyName, 'companyName', 'courierData', 'formData')" maxlength="100">
                            <i class="material-icons" v-if="validCourierDataValues[7].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[7].value == 1">{{ validCourierDataValues[7].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.number">Numer telefonu</h6>
                        </header>
                        <div class="input-box">
                            <input type="number" class="data" :class="{ error: validCourierDataValues[2].value == 1 }" placeholder="Numer telefonu*" v-model="courierData.number" @keydown="preventNumberInput" @blur="storeObjectInLocalStore(courierData.number, 'number', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[2].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[2].value == 1">{{ validCourierDataValues[2].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.street">Ulica</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[3].value == 1 }" placeholder="Ulica*" v-model="courierData.street" @blur="storeObjectInLocalStore(courierData.street, 'street', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[3].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[3].value == 1">{{ validCourierDataValues[3].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.houseNumber">Numer domu/mieszkania</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[4].value == 1 }" placeholder="Numer domu/mieszkania*" v-model="courierData.houseNumber" @blur="storeObjectInLocalStore(courierData.houseNumber, 'houseNumber', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[4].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[4].value == 1">{{ validCourierDataValues[4].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.postCode">Kod pocztowy</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[5].value == 1 }" placeholder="Kod pocztowy*" v-model="courierData.postCode" @blur="storeObjectInLocalStore(courierData.postCode, 'postCode', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[5].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[5].value == 1">{{ validCourierDataValues[5].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.city">Miasto</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" :class="{ error: validCourierDataValues[6].value == 1 }" placeholder="Miasto*" v-model="courierData.city" @blur="storeObjectInLocalStore(courierData.city, 'city', 'courierData', 'formData')">
                            <i class="material-icons" v-if="validCourierDataValues[6].value == 1">close</i>
                        </div>
                        <p v-if="validCourierDataValues[6].value == 1">{{ validCourierDataValues[6].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="courierData.comments">Uwagi dla kuriera</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" maxlength="100" placeholder="Uwagi dla kuriera" v-model="courierData.comments" @blur="storeObjectInLocalStore(courierData.comments, 'comments', 'courierData', 'formData')">
                        </div>
                    </div>
                </div>
            </section>
            <section class="regulationsForm">
                <header>
                    <h4>Zgody formalne</h4>
                </header>
                <div class="data">
                <div class="input-container">
                    <div class="input-checkbox">
                    <div class="checkbox" @click="checkCheckBox(0)">
                        <i class="material-icons" v-if="checkBoxList[0].value == 1">done</i>
                    </div>
                    <p>Zaznacz wszystkie</p>
                    </div>
                </div>
                <div class="input-container">
                    <div class="input-checkbox">
                    <div class="checkbox" :class="{ error: validValues[3].value == 1 && checkBoxList[1].value != 1 }" @click="checkCheckBox(1)">
                        <i class="material-icons" v-if="checkBoxList[1].value == 1">done</i>
                    </div>
                    <p>* Akceptuję postanowienia <a href="#">Regulaminu</a></p>
                    </div>
                    <p class="checkbox" v-if="validValues[3].value == 1 && checkBoxList[1].value != 1">Pole wymaga zaznaczenia</p>
                </div>
                <div class="input-container">
                    <div class="input-checkbox">
                    <div class="checkbox" :class="{ error: validValues[4].value == 1 && checkBoxList[2].value != 1 }" @click="checkCheckBox(2)">
                        <i class="material-icons" v-if="checkBoxList[2].value == 1">done</i>
                    </div>
                    <p>* Oświadczam, że podane przeze mnie dane są prawidłowe.</p>
                    </div>
                    <p class="checkbox" v-if="validValues[4].value == 1 && checkBoxList[2].value != 1">Pole wymaga zaznaczenia</p>
                </div>
                <div class="input-container">
                    <div class="input-checkbox">
                    <div class="checkbox" :class="{ error: validValues[5].value == 1 && checkBoxList[3].value != 1 }" @click="checkCheckBox(3)">
                        <i class="material-icons" v-if="checkBoxList[3].value == 1">done</i>
                    </div>
                    <p>* Potwierdzam zapoznanie się z <a href="./polityka_prywatnosci.pdf" target="_blank">Polityką Prywatności</a> dotyczącą przetwarzania danych osobowych przez AFK Centrum Obsługi Biznesu Sp. z o.o..</p>
                    </div>
                    <p class="checkbox" v-if="validValues[5].value == 1 && checkBoxList[3].value != 1">Pole wymaga zaznaczenia</p>
                </div>
                <div class="input-container" v-if="!tokens">
                    <div class="input-checkbox">
                    <div class="checkbox" @click="checkCheckBox(4)">
                        <i class="material-icons" v-if="checkBoxList[4].value == 1">done</i>
                    </div>
                    <p>Wyrażam zgodę na przetwarzanie moich danych osobowych przez AFK Centrum Obsługi Biznesu Sp. z o.o. (AFK COB) z siedzibą we Wrocławiu ul. Świeradowska 51-57 do celów marketingu bezpośredniego, w tym na otrzymywanie informacji marketingowych o ofercie AFK COB a także Partnerów serwisu 
                        <br><span class="action" v-if="checkBoxExtended == 0" @click="checkBoxExtend()">rozwiń</span>
                        <span v-if="checkBoxExtended == 1"> z użyciem telekomunikacyjnych urządzeń końcowych i tzw. automatycznych systemów wywołujących w formie wiadomości elektronicznych (e-mail, SMS/MMS, serwisy internetowe, w tym portale społecznościowe) oraz połączeń głosowych (rozmowa telefoniczna), również wtedy, gdy nie jestem klientem AFK COB. Potwierdzam, że poinformowano mnie o możliwości wycofania zgody na przetwarzanie danych poprzez usunięcia konta na portalu afk-cob.pl w trybie opisanym w  
                        <a href="./regulamin_15.04.2021.pdf" target="_blank">Regulaminie</a>. </span>
                        <br><span class="action" v-if="checkBoxExtended == 1" @click="checkBoxExtend()">zwiń</span>
                    </p>
                    </div>
                </div>
                </div>
            </section>
        </div>
        <order-nav forwardString="Kontynuuj" @goBack="goBack" :backPushingWay="backPushingWay" :forwardPushingWay="forwardPushingWay" forwardPath="/zamowienie/krok/3" :forwardDisabled="true" @validation="validateFields()"></order-nav>
    </div>
</template>

<script>
    import localStorageManager from '../functions/localStorageManager';
    import validation from '../functions/validation';
    import OrderNav from '@/components/OrderNav.vue';
    import Loader from '../components/Loader';

    export default {
        name: 'Step2RegisterAndRegulations',
        components: {
            OrderNav,
            Loader,
        },
        data() {
            return {
                loading: false,
                contractSigningMethod: 1,
                backPushingWay: 1,
                forwardPushingWay: 0,
                email: '',
                password1: '',
                password2: '',
                haveAccount: '',
                addCompany: '',
                checkBoxExtended: 0,
                checkBoxList: [
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                ],
                password: [
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                    { value: 0 },
                ],
                validValues: [
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                ],
                msg: 'Poprawnie wypełnij pola',
                courierData: {
                    name: '',
                    surname: '',
                    companyName: '',
                    number: '',
                    street: '',
                    houseNumber: '',
                    postCode: '',
                    city: ''
                },
                validCourierDataValues: [
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                    { value: 0, text: 'Podana wartość jest nieprawidłowa', },
                ],
                infoTexts: [
                    'W przypadku wybrania opcji Przez Kuriera umowę dostarczy kurier na wskazany adres. W przypadku wybrania opcji Na miejscu w siedzibie AFK umowę podpiszesz w siedzibie AFK Centrum Obsługi Biznesu Sp. z o.o. ul. Świeradowska 51-57, Wrocław.',
                ],
            }
        },
        methods: {
            adjustCheckBox(){
                let checker = 0;
                for(let i = 1; i < this.checkBoxList.length; i++){
                    if(this.checkBoxList[i].value == 0){
                        checker = 1;
                    }
                }
                if(this.checkBoxList[0].value == 1 && checker == 1){
                    this.checkBoxList[0].value = 0;
                }
                if(this.checkBoxList[0].value == 0 && checker == 0){
                    this.checkBoxList[0].value = 1;
                }
            },
            checkCheckBox(id){
                if(id != 0){
                    if(this.checkBoxList[id].value == 1){
                        this.checkBoxList[id].value = 0;
                    }else{
                        this.checkBoxList[id].value = 1;
                    }
                }else{
                    if(this.checkBoxList[id].value == 1){
                        status = 0;
                    }else{
                        status = 1;
                    }
                    for(let i = 0; i < this.checkBoxList.length; i++){
                        this.checkBoxList[i].value = status;
                    }
                }
                this.adjustCheckBox();
            },
            checkBoxExtend() {
                this.checkBoxExtended = !this.checkBoxExtended
            },
            storeInLocalStorage(value, valueName, objectName) {
                localStorageManager.storeInLocalStorage(value, valueName, objectName);
            },
            storeObjectInLocalStore(value, key, valueName, objectName) {
                localStorageManager.storeObjectInLocalStore(value, key, valueName, objectName);
            },
            passwordIcon(id){
                if(id){
                    return 'done';
                }else{
                    return 'close';
                }
            },
            goBack() {
                this.$emit('goBack');
            },
            validateCheckBoxes() {
                for(let i = 1; i < (this.checkBoxList.length - 1); i++){
                    if(this.checkBoxList[i].value == 0){
                        this.validValues[i + 2].value = 1;
                    }else{
                        this.validValues[i + 2].value = 0;
                    }
                }
            },
            validateCourierData() {
                this.validCourierDataValues[0] = validation.validateStringWithoutNumbers(this.courierData.name, this.validCourierDataValues[0], 50);
                this.validCourierDataValues[1] = validation.validateStringWithoutNumbers(this.courierData.surname, this.validCourierDataValues[1], 50);
                this.validCourierDataValues[2] = validation.validatePhoneNumber(this.courierData.number, this.validCourierDataValues[2]);
                this.validCourierDataValues[3] = validation.validateString(this.courierData.street, this.validCourierDataValues[3], 50);
                this.validCourierDataValues[4] = validation.validateString(this.courierData.houseNumber, this.validCourierDataValues[4], 50);
                this.validCourierDataValues[5] = validation.validatePostalCode(this.courierData.postCode, this.validCourierDataValues[5]);
                this.validCourierDataValues[6] = validation.validateString(this.courierData.city, this.validCourierDataValues[6], 50);
                this.validCourierDataValues[7] = validation.validateString(this.courierData.companyName, this.validCourierDataValues[7], 100);
            },
            validateEmail() {
                this.validValues[0] = validation.validateEmail(this.email, this.validValues[0]);
            },
            validatePassword() {
                let condition = 0;
                for(let i = 0; i < this.password.length; i++){
                    if(this.password[i].value == 0){
                    condition = 1;
                    }
                }
                const validatedPassword = validation.validatePasswords(this.password1, this.password2, condition, this.validValues[1], this.validValues[2]);
                this.validValues[1] = validatedPassword[0];
                this.validValues[2] = validatedPassword[1];
            },
            async validateFields() {
                this.$store.commit('changeValidateStep', false);
                if(this.haveAccount == 0) {
                    this.validateEmail();
                    this.validatePassword();
                };
                if(this.contractSigningMethod == 1) {
                    this.validateCourierData();
                } else {
                    this.validCourierDataValues.forEach(element => {
                        element.value = 0;
                    });
                };
                this.validateCheckBoxes();
                if(this.validValues.filter(element => element.value == 1).length > 0
                    || this.validCourierDataValues.filter(element => element.value == 1).length > 0) {
                    this.$store.commit('changeValidateStep', false);
                    this.toggleAlert(0, this.msg);
                    return;
                } else {
                    const formData = JSON.parse(localStorage.formData);
                    if(this.contractSigningMethod == 0) {
                        if(formData.courierData) {
                            delete formData.courierData;
                        }
                    }
                    localStorage.setItem('formData', JSON.stringify(formData));
                    var payload = {
                        nip: formData.nip,
                        contractSigners: [],
                        correspondenceData: {
                            city: formData.correspondenceAddress.city,
                            street: formData.correspondenceAddress.street,
                            houseNumber: formData.correspondenceAddress.houseNumber,
                            postCode: formData.correspondenceAddress.postCode,
                            comments: formData.correspondenceAddress.comments,
                            phoneNumber: [],
                            email: [],
                        },
                        correspondencePersons: [],
                    }
                    if(this.haveAccount == 0) {
                        payload.registerData = {
                            email: formData.email,
                            password: this.password1,
                            confirmPassword: this.password2,
                            personalDataProcessing: this.checkBoxList[4].value,
                        };
                    } else {
                        payload.registerData = {
                            personalDataProcessing: this.checkBoxList[4].value
                        };
                    };
                    if(formData.krs) {
                        payload.companyData = {
                            krs: formData.krs,
                        };
                    };

                    formData.contractSigners.forEach(person => {
                        if(person.position === 'inne') {
                            person.position = person.otherPosition;
                        }
                        if(person.picked) {
                            payload.contractSigners.push({
                                name: person.name,
                                surname: person.surname,
                                identity_card: person.id,
                                position: person.position,
                                identity_card_type: person.identity_card_type,
                                picked: true
                            });
                        } else {
                            payload.contractSigners.push({
                                name: person.name,
                                surname: person.surname,
                                identity_card: person.id,
                                position: person.position,
                                identity_card_type: person.identity_card_type
                            });
                        };
                    });

                    formData.correspondenceNumber.forEach(number => {
                        payload.correspondenceData.phoneNumber.push(number.number);
                    });

                    formData.correspondenceEmail.forEach(email => {
                        payload.correspondenceData.email.push(email.email);
                    });

                    formData.correspondencePeople.forEach(person => {
                        payload.correspondencePersons.push({
                            name: person.name,
                            surname: person.surname,
                            identity_card: person.id,
                            identity_card_type: person.identity_card_type
                        });
                    });
                    this.loading = true;
                    if(this.haveAccount == 0 && this.haveCompany != -1) {
                        await this.axios
                        .post(this.api + 'vo/order/form/woacc', payload)
                        .then(res => {
                            if(res.data.status != 1) {
                                if(res.data.taken) {
                                    this.validValues[0].value = 1;
                                    this.validValues[0].text = 'Podany email jest zajęty';
                                }
                                this.$store.commit('changeValidateStep', false);
                                this.toggleAlert(0, this.msg);
                                this.loading = false;
                            } else {
                                localStorage.setItem('accessToken', res.data.accessToken);
                                localStorage.setItem('refreshToken', res.data.refreshToken);
                                const formData = JSON.parse(localStorage.formData);
                                formData.companyId = res.data.companyId;
                                localStorage.setItem('formData', JSON.stringify(formData));
                                this.$store.commit('togglePopupCode', 1);
                                localStorage.setItem('formStep', 3);
                                this.disableAdditionalDataFields();
                                this.updateContractSignersIds(res.data.contractSigners);
                                this.loading = false;
                            }
                        })
                    } else if(this.addCompany == 1 && this.haveAccount == 1 && this.haveCompany != -1) {
                        await this.axios
                        .post(this.api + 'vo/order/form/wacc', payload)
                        .then(res => {
                            if(res.data.status != 1) {
                                this.$store.commit('changeValidateStep', false);
                                this.msg = res.data.msg;
                                this.toggleAlert(0, this.msg);
                                this.loading = false;
                            } else {
                                this.$store.commit('changeValidateStep', true);
                                let formData = JSON.parse(localStorage.formData);
                                formData.companyId = res.data.companyId;
                                localStorage.setItem('formData', JSON.stringify(formData));
                                localStorage.setItem('formStep', 3);
                                this.disableAdditionalDataFields();
                                this.updateContractSignersIds(res.data.contractSigners);
                                this.loading = false;
                            }
                        })
                    } else if(this.addCompany == 0 && this.haveAccount == 1) {
                        await this.axios
                        .put(this.api + 'vo/order/form/', payload)
                        .then(res => {
                            if(res.data.status == 1) {
                                this.$store.commit('changeValidateStep', true);
                                localStorage.setItem('formStep', 3);
                                localStorage.setItem('activationFee', res.data.activationFee);
                                this.disableAdditionalDataFields();
                                this.updateContractSignersIds(res.data.contractSigners);
                                this.loading = false;
                            } else {
                                this.$store.commit('changeValidateStep', false);
                                this.msg = res.data.msg;
                                this.toggleAlert(0, this.msg);
                                this.loading = false;
                            }
                        }).catch(e => {
                            console.log(e);
                        });
                    }
                };
            },
            disableAdditionalDataFields() {
                let formData = JSON.parse(localStorage.formData);
                Object.keys(formData).forEach(key => {
                    if(Array.isArray(formData[key])) {
                        formData[key].forEach(element => {
                            if(element.disabled == false) {
                                element.disabled = true;
                                element.picked = true;
                            }
                        });
                    }
                });
                localStorage.setItem('formData', JSON.stringify(formData));
            },
            updateContractSignersIds(contractSigners) {
                let formData = JSON.parse(localStorage.formData);
                formData.contractSigners.forEach(person => {
                    contractSigners.forEach(signer => {
                        if(person.name == signer.name && person.surname == signer.surname && person.position == signer.position && !person.id) {
                            if(signer.id) {
                                person.id = signer.id;
                                signer.id = 0;
                            };
                        };
                    });
                });
                localStorage.setItem('formData', JSON.stringify(formData));
            },
            preventNumberInput(e) {
                if(e.keyCode == 69
                || e.keyCode == 107
                || e.keyCode == 109
                || e.keyCode == 110
                || e.keyCode == 187
                || e.keyCode == 188
                || e.keyCode == 189
                || e.keyCode == 190) {
                    e.preventDefault();
                }
            },
            showPopup(id) {
                this.$emit('showPopup', this.infoTexts[id]);
            },
            toggleAlert(type, msg) {
                this.$store.commit('toggleAlert', {
                    visibility: 1,
                    type: type,
                    msg: msg
                });
            },
        },
        computed: {
            api(){
                return this.$store.state.api;
            },
            isOrderNavDisabled() {
                var inputsElements = [];
                var emptyValues = [0];
                if(this.haveAccount == 0) {
                    inputsElements.push(this.email, this.password1, this.password2);
                }
                
                inputsElements.filter((element) => {
                    if(element === '') {
                        emptyValues.push(1);
                    } else {
                        emptyValues.push(0);
                    };
                });

                return emptyValues.reduce((a, b) => { return a + b });
            },
            tokens() {
                if(localStorage.accessToken && localStorage.refreshToken) {
                    return 1;
                } else {
                    return 0;
                };
            },
        },
        watch: {
            password1(){
                let regex = RegExp('[a-z]');
                let regex1 = RegExp('[A-Z]');
                let regex2 = RegExp('[0-9]');
                let regex3 = RegExp('\\W');
                if(this.password1.length >= 8 ){
                    this.password[0].value = 1;
                }else{
                    this.password[0].value = 0;
                }
                if(regex1.test(this.password1)){
                    this.password[1].value = 1;
                }else{
                    this.password[1].value = 0;
                }
                if(regex.test(this.password1)){
                    this.password[2].value = 1;
                }else{
                    this.password[2].value = 0;
                }
                if(regex3.test(this.password1)){
                    this.password[3].value = 1;
                }else{
                    this.password[3].value = 0;
                }
                if(regex2.test(this.password1)){
                    this.password[4].value = 1;
                }else{
                    this.password[4].value = 0;
                }
                // if(!this.password1.toLowerCase().includes(this.name.toLowerCase()) && !this.password1.toLowerCase().includes(this.surname.toLowerCase())){
                //   this.password[5].value = 1;
                // }else{
                //   this.password[5].value = 0;
                // }
                this.password[5].value = 1;
            },
            isOrderNavDisabled(emptyValues) {
                if(emptyValues > 0) {
                    this.$store.commit('changeOrderNavDisable', true);
                } else {
                    this.$store.commit('changeOrderNavDisable', false);
                };
            },
        },
        mounted() {
            if(localStorage.refreshToken && localStorage.accessToken) {
                this.haveAccount = 1;
            };
            this.$store.commit('changeOrderNavDisable', true);
            this.storeInLocalStorage(this.contractSigningMethod, 'contractSigningMethod', 'step2State');
            if(localStorage.formData !== undefined) {
                const formData = JSON.parse(localStorage.formData);
                Object.keys(formData).forEach(key => {
                    if(this[key] == '' || this[key]) {
                        this[key] = formData[key];
                    }
                });
            }
            if(localStorage.step2State !== undefined) {
                const step2State = JSON.parse(localStorage.step2State);
                Object.keys(step2State).forEach(key => {
                    if(this[key] == '' || this[key]) {
                        this[key] = step2State[key];
                    }
                });
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
